//TREND ANGGOTA
export const GET_OVERVIEW_PROVINSI = "GET_OVERVIEW_PROVINSI";
export const GET_OVERVIEW_PROVINSI_SUCCESS = "GET_OVERVIEW_PROVINSI_SUCCESS";
export const GET_OVERVIEW_PROVINSI_FAIL = "GET_OVERVIEW_PROVINSI_FAIL";

export const GET_OVERVIEW_KABKOT = "GET_OVERVIEW_KABKOT";
export const GET_OVERVIEW_KABKOT_SUCCESS = "GET_OVERVIEW_KABKOT_SUCCESS";
export const GET_OVERVIEW_KABKOT_FAIL = "GET_OVERVIEW_KABKOT_FAIL";

export const GET_OVERVIEW_KECAMATAN = "GET_OVERVIEW_KECAMATAN";
export const GET_OVERVIEW_KECAMATAN_SUCCESS = "GET_OVERVIEW_KECAMATAN_SUCCESS";
export const GET_OVERVIEW_KECAMATAN_FAIL = "GET_OVERVIEW_KECAMATAN_FAIL";

export const GET_OVERVIEW_KELURAHAN = "GET_OVERVIEW_KELURAHAN";
export const GET_OVERVIEW_KELURAHAN_SUCCESS = "GET_OVERVIEW_KELURAHAN_SUCCESS";
export const GET_OVERVIEW_KELURAHAN_FAIL = "GET_OVERVIEW_KELURAHAN_FAIL";

export const GET_OVERVIEW_RT_RW = "GET_OVERVIEW_RT_RW";
export const GET_OVERVIEW_RT_RW_SUCCESS = "GET_OVERVIEW_RT_RW_SUCCESS";
export const GET_OVERVIEW_RT_RW_FAIL = "GET_OVERVIEW_RT_RW_FAIL";

export const GET_OVERVIEW_KOMISARIS_BASIS = "GET_OVERVIEW_KOMISARIS_BASIS";
export const GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS =
  "GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS";
export const GET_OVERVIEW_KOMISARIS_BASIS_FAIL =
  "GET_OVERVIEW_KOMISARIS_BASIS_FAIL";
